import type { FC } from "react";

import { Button } from "../../common/Button";

interface StepSuccessCardProps {
  title: string;
  description: string;
  onContinue?: () => void;
}

export const StepSuccessCard: FC<StepSuccessCardProps> = ({
  title,
  description,
  onContinue,
}) => (
  <div className="space-y-4">
    <div className="flex items-center gap-3">
      <div className="inline-grid size-10 place-items-center border border-emerald-500/30 bg-emerald-500/10">
        <span className="font-mono text-sm text-emerald-400">■</span>
      </div>
      <div>
        <h2 className="font-mono text-sm font-bold uppercase tracking-widest text-white">
          {title}
        </h2>
        <p className="mt-0.5 font-mono text-[10px] font-bold uppercase tracking-widest text-emerald-400">
          {description}
        </p>
      </div>
    </div>

    {onContinue && (
      <Button onClick={onContinue} fullWidth>
        Continue
      </Button>
    )}
  </div>
);
